// src/main.js
import Vue from 'vue';
import App from './App.vue';
import router from './router';  // 引入路由配置
// 引入公共样式
import '@/assets/styles/styles.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
// import 'bootstrap/dist/css/bootstrap.min.css';

// import BootstrapVue from 'bootstrap-vue';
import './utils/flexible';

// 使用 BootstrapVue 插件
// Vue.use(BootstrapVue)

Vue.use(VueAwesomeSwiper);

Vue.config.productionTip = false;

// main.js 或 router/index.js
router.afterEach(() => {
  // 确保 DOM 更新后再滚动
  Vue.nextTick(() => {
    window.scrollTo(0, 0) // 整个窗口置顶
    // 若为局部容器（如 #app），用：
    // document.getElementById('app')?.scrollTo(0, 0)
  })
})

new Vue({
  render: (h) => h(App),
  router,  // 在 Vue 实例中启用路由
}).$mount('#app');
